export const locale = {
    lang: "en-US",
    data: {
        DIALOG: {
            TITLE: "Errors when importing users",
            VALIDS: "lines to be imported",

            GRID: {
                LINE: "Line",
                EMAIL: "Email",
                ERRORS: "Errors"
            },
            COPY: "Copy erro",
            COPY_ALL: "Copy All",
            COPIED: "Errors copied successfully."
        }
    }
};
